import { startOfLocalDay } from './localDay';

const DAY = 86400000;

// Calendar difference in local days (not hours): 23:50 yesterday is "yesterday" at 00:00 today.
const localDayDiff = (then, now) =>
    Math.round((startOfLocalDay(now) - startOfLocalDay(then)) / DAY);

/** "today" | "yesterday" | "n days ago"; '' for a future date (bad data shows no "ago"). */
export const daysAgoText = (then, now) => {
    const n = localDayDiff(then, now);
    if (n < 0) return '';
    if (n === 0) return 'today';
    return n === 1 ? 'yesterday' : `${n} days ago`;
};

/** Elapsed time between two instants, for sign-ins: "just now" | "n h ago" | "n d ago". */
export const hoursAgoText = (then, now) => {
    const ms = new Date(now) - new Date(then);
    if (ms < 0) return '';
    const hours = ms / 3600000;
    if (hours < 1) return 'just now';
    if (hours < 24) return `${Math.round(hours)} h ago`;
    return `${Math.floor(hours / 24)} d ago`;
};
